





























































































// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
import * as StudyAPI from "@/services/api/studies";
import { useTags } from "@/hooks/useTags";
import { StudyList, IStudyList } from "@/components.studies/study-list";
import { AssetList } from "@/components.assets/asset-list";
import { AssetGrid } from "@/components.assets/asset-grid";
import { ContextOption } from "@/components.generic/context-menu";
import { Asset } from "@/psychlab/types";
import * as AppModal from "@/AppModal";
// local
import { useTagInfo } from "./useTagInfo";

import { ContextHeader } from "@/components.nav/context-header";
import { useTranslate } from "@lang";
import { Container, Divider, Heading, AbsBox } from "@ui";

export default defineComponent({
	components:{
		StudyList,
		AssetList,
		AssetGrid,
		Container,
		Divider,
		Heading,
		AbsBox,
		ContextHeader,
	},
	setup(props, context){


		const studyList = ref<IStudyList>();

		const tagHooks = useTags();

		const tag = computed(() => {
			return tagHooks.getCachedTag(context.root.$route.params["tagId"]);
		});

		const tagId = computed(() => context.root.$route.params["tagId"]);

		const { translate } = useTranslate();
		

		const {
			blueprintCount,
			elementCount,
			studyCount,
			refresh:refreshTagInfo
		} = useTagInfo(tagId.value);

		const editName = () => {
			const t = tag.value;
			if(!t){ return; }

			AppModal.editText({
				value:t.name,
				title:translate("tags.action.renameTag"),
				validator(v){
					return t.name !== v;
				},
			}, async (v) => {
				tagHooks.editTag(t._id, { name:v });
			});
		};

		const editColor = () => {
			const t = tag.value;
			if(!t){ return; }
			AppModal.editColor({
				value:t.color,
				title:translate("action.setColor")
			}, async(v) => {
				tagHooks.editTag(t._id, { color:v });
			});
		};

		const createStudy = (blueprint:string) => {
			AppModal.createStudy({
				blueprint,
			}, async (r) => {
				const { name, study, version, language, openDashboard } = r;
				const s = await StudyAPI.createStudy({ name, blueprint:`${study}@${version}`, language });
				if(studyList.value){
					studyList.value.refresh();
					studyList.value.setSort("created");
				}

				if(openDashboard){
					context.root.$router.push({
						name:"Run.Group",
						params:{
							groupId:s._id,
						}
					});
				}
			});
		};

		const openContext = (e:Event) => {
			AppModal.context(e, [
				{
					name:translate("action.rename"),
					icon:"mdi.pencil-box",
					fn:editName,
				},
				{
					name:translate("action.editColor"),
					icon:"mdi.palette",
					fn:editColor,
				}

			])
		};

		const getContextOptions = (a:Asset):ContextOption[] => {
			
			return [
				{
					name:translate("studies.action.createStudy"),
					icon:"mdi.rocket mdi-rotate-45",
					fn(){
						createStudy(a._id);
					},
					order:-1,
				}
			];
		};

		const onStudiesRefreshed = () => {
			refreshTagInfo();
		};

		return {
			tag,
			editName,
			translate,
			editColor,
			getContextOptions,
			studyList,
			openContext,
			onStudiesRefreshed,
			blueprintCount,
			elementCount,
			studyCount,
		};
	}
});

